<template>
  <div class="cen-p">
    <el-button @click="save" size="mini" type="primary" class="save-btn">保存文件下载地址</el-button>
    <h1 class="p-center center">订单文件批量下载流程</h1>
    <h3 class="p-center p1">方案1· 基于命令行的下载工具</h3>
    <p class="p-center">1：进入我的订单，点击下载“一键获取下载地址”</p>
    <img src="@/assets/image/operat/1.png" alt="">
    <p class="p-center">例如保存的文件名为test.txt</p>
    <img src="@/assets/image/operat/2.png" alt="">
    <p class="p-center">2：以下用test.txt做为下载示例文件</p>
    <h4 class="p-center">①Windows系统中的批处理脚本</h4>
    <p class="p-center">Windows环境的批处理脚本下载地址: </p>
    <a class="p-center" href="http://120.196.115.131:8101/productImages/download.bat">http://120.196.115.131:8101/productImages/download.bat</a>
    <p class="p-center">下载时截图</p>
    <img src="@/assets/image/operat/3.png" alt="">
    <p class="p-center">下载完成截图</p>
    <img src="@/assets/image/operat/4.png" alt="">
    
    
    
    
    
    <h4 class="p-center">②Linux系统中的脚本</h4>
    <p class="p-center">Linux环境的批处理脚本下载地址： </p>
    <a class="p-center" href="http://120.196.115.131:8101/productImages/download.sh">http://120.196.115.131:8101/productImages/download.sh</a>
    <p class="p-center">下载时截图</p>
    <img src="@/assets/image/operat/5.png" alt="">
    <p class="p-center">下载完成截图</p>
    <img src="@/assets/image/operat/6.png" alt="">




    <h3 class="p-center p1">方案2· 基于迅雷批量下载的教程</h3>
    <p class="p-center">1：点击新建</p>
    <img src="@/assets/image/operat/7.png" alt="">
    <img src="@/assets/image/operat/8.png" alt="">
    <p class="p-center">2：打开test.txt，把文档内容粘贴进迅雷并点击立即下载</p>
    <img src="@/assets/image/operat/9.png" alt="">
    <p class="p-center">3：等待下载完成</p>
    <img src="@/assets/image/operat/10.png" alt="">
    <img src="@/assets/image/operat/11.png" alt="">
  </div>
</template>

<script>
import {
  downloadAll
} from "@/api/Order/index"
export default {
    data(){
        return {

        }
    },
    methods:{
      save(){
        this.copyDownUrl(this.$route.query.orderId)
      },
      /**
       * @description: 根据orderid查询下载链接并且复制到剪切板
       * @brief:
       * @Author: chenwei
       * @Date: 2022-09-15 13:10:24
       * @param {*} orderId
       * @return {*}
       */
      async copyDownUrl(orderId) {
        let res = await downloadAll({orderId: orderId})
        let ele_a = document.createElement("a")
        let fileName = "data.txt"
        ele_a.download = fileName
        ele_a.style.display = "none"
        let blob = new Blob([res.data.join("\r\n")], {type: "text/plain"})
        ele_a.href = URL.createObjectURL(blob)
        document.body.appendChild(ele_a)
        ele_a.click()
        setTimeout(function () {
          document.body.removeChild(ele_a)
        }, 500)
      },
    }
}
</script>

<style lang="scss" scoped>
.save-btn{
  position: fixed;
  right: 24px;
  top: 48px;
}
.cen-p{
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 24px 60px;
  background: rgba(249, 249, 249, 1);
}
.p-center{
    text-align: center;
}
img{
  width: 640px;
  margin: 12px auto;
  border: 20px solid white;
}
p{
  margin: 8px 0;
}
</style>